// Seiten, die erst beim ersten Öffnen geladen werden (Tempo, 19.10.2026): Der Start lädt und übersetzt nur noch, was
// Posteingang, Smart Views und Lead-Seite brauchen. Berichte, Workflows, Einstellungen usw. kommen als eigene Dateien nach.
//
// Nach einem Ausrollen gibt es die alten Dateien auf dem Server nicht mehr. Wer dann eine noch nicht geladene Seite öffnet,
// bekommt statt eines weißen Bildschirms einen Hinweis mit "Neu laden" (nie ein automatisches Neuladen: ein Gespräch
// würde getrennt).
import { lazy, type ComponentType } from "react";

function ChunkFehler() {
  return (
    <div className="seite">
      <h1>Seite konnte nicht geladen werden</h1>
      <p className="seite__text">
        Das CRM wurde inzwischen aktualisiert, diese Ansicht gehört zur alten Fassung. Bitte die Seite neu laden (laufende Gespräche
        vorher beenden).
      </p>
      <button type="button" className="knopf" onClick={() => window.location.reload()}>
        Neu laden
      </button>
    </div>
  );
}

export function lazySeite<T extends ComponentType<any>>(laden: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      return await laden();
    } catch {
      return { default: ChunkFehler as unknown as T };
    }
  });
}
